import type { ShareLinkOptions } from "./shareLinks.types";

/** Options the preview uses before an embed row exists. */
export const DEFAULT_PREVIEW_OPTIONS: Pick<ShareLinkOptions, "header" | "nav" | "chrome" | "fullscreen" | "theme"> = {
  header: true,
  nav: true,
  chrome: true,
  fullscreen: false,
  theme: "auto",
};

/** The owner-preview iframe URL for an embed: the preview token plus the embed's look options. Null until a token exists. */
export const embedPreviewSrc = (
  origin: string,
  token: string | null | undefined,
  options: Pick<ShareLinkOptions, "header" | "nav" | "chrome" | "fullscreen" | "theme"> = DEFAULT_PREVIEW_OPTIONS,
): string | null =>
  token
    ? `${origin}/embed/${token}?${new URLSearchParams({
        header: String(options.chrome && options.header),
        toolbar: String(options.chrome && options.nav),
        fullscreen: String(options.fullscreen),
        ...(options.theme === "auto" ? {} : { theme: options.theme }),
      }).toString()}`
    : null;
